import React from 'react';

const WidgetContainer = ({ children, className = '', delay = 0 }) => {
  return (
    <div
      className={`glass-card p-5 md:p-6 ${className}`}
      style={{
        position: 'relative',
        overflow: 'visible',
        height: '100%',
      }}
      data-widget-delay={delay}
    >
      {children}
    </div>
  );
};

export default WidgetContainer;
